
export default {
    inject: ['EventBus', 'PIXIWrapper'],

    props: {
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        },
        zIndex: {
            type: Number
        },
        interactive: {
            type: Boolean,
            default: true
        },
        pointer: {
            type: Boolean,
            default: false
        },
        angle: {
            type: Number,
            default: 0
        },
        positionX: {
            type: Number,
            default: 0
        },
        positionY: {
            type: Number,
            default: 0
        },
        debug: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            container: null
        };
    },

    watch: {
        angle () {
            this.container.angle = this.angle;
        },
        interactive () {
            this.container.interactive = this.interactive;
        },
        positionX () {
            this.container.position.x = this.positionX * this.PIXIWrapper.sizes.scaleFactorX;
        },
        positionY () {
            this.container.position.y = this.positionY * this.PIXIWrapper.sizes.scaleFactorY;
        }
    },

    created () {
        this.draw();
    },

    destroyed () {
        if (this.container !== null && !this.container._destroyed) {
            this.container.destroy(true);
        }
    },

    methods: {
        /**
         * Draw the container.
         */
        draw () {
            this.container = new this.PIXIWrapper.PIXI.Container();

            this.container.x = this.x * this.PIXIWrapper.sizes.scaleFactorX;
            this.container.y = this.y * this.PIXIWrapper.sizes.scaleFactorY;

            if (this.zIndex !== undefined) {
                this.container.zIndex = this.zIndex;
            }

            if (this.pointer) {
                this.container.cursor = 'pointer';
            }

            this.container.angle = this.angle;

            this.container.position.x = this.positionX * this.PIXIWrapper.sizes.scaleFactorX;
            this.container.position.y = this.positionY * this.PIXIWrapper.sizes.scaleFactorY;

            this.container.scale.set(this.PIXIWrapper.sizes.scaleFactorX, this.PIXIWrapper.sizes.scaleFactorY);

            this.container.sortableChildren = true;

            if (this.interactive) {
                this.defineEvents();
            }

            if (this.debug) {
                this.container.on('pointerdown', (event) => {
                    console.log(
                        parseInt(event.data.originalEvent.layerX / this.PIXIWrapper.sizes.scaleFactorX),
                        parseInt(event.data.originalEvent.layerY / this.PIXIWrapper.sizes.scaleFactorY)
                    );
                });
            }

            if (this.$parent.container) {
                // If the parent is another container, add to it.
                this.$parent.container.addChild(this.container);
            } else {
                // Otherwise it's a direct descendant of the renderer stage.
                this.PIXIWrapper.app.stage.addChild(this.container);
            }
        },

        /**
         * Define all pixi events that should be emitted ($emit) to the parent component.
         * Only events that are used in parent component ($listeners) will be attached.
         */
        defineEvents () {
            let eventList = [
                'added',
                'click',
                'mousedown',
                'mousemove',
                'mouseout',
                'mouseover',
                'mouseup',
                'mouseupoutside',
                'pointercancel',
                'pointerdown',
                'pointermove',
                'pointerout',
                'pointerover',
                'pointertap',
                'pointerup',
                'pointerupoutside',
                'removed',
                'rightclick',
                'rightdown',
                'rightup',
                'rightupoutside',
                'tap',
                'touchcancel',
                'touchend',
                'touchendoutside',
                'touchmove',
                'touchstart'
            ];

            this.container.interactive = true;

            eventList
                .filter(eventName => Object.keys(this.$listeners).includes(eventName))
                .forEach(eventName => {
                    this.container.on(eventName, (event) => {
                        this.$emit(eventName, {
                            element: this.container,
                            event,
                            AnimationManager: this.PIXIWrapper.AnimationManager
                        });
                    });
                });
        }
    },

    render (h) {
        return h('template', this.$slots.default);
    }
};
